import { useAddNativeClasses } from '@carvana/merch-native/hooks';
import { useContext } from 'react';
import AppRouterComposerEvents from '~/components/home/AppRouterComposerEvents';
import PagesRouterComposerEvents from '~/components/home/PagesRouterComposerEvents';
import { heliosSizes } from '~/constants/common/resizeBreakpoints';
import { useNativeDeviceType } from '~/context/common/DeviceContext';
import { useIsAppRouter } from '~/context/common/StaticContext';
import TradeContext from '~/context/common/TradeContext';
import { useIsLoggedIn } from '~/context/common/UserContext';
import GlobalContext from '~/context/home/GlobalContext';
import ModalContext from '~/context/home/ModalContext';
import { useGetFavorites } from '~/hooks/common/favorites';
import useGeolocation from '~/hooks/common/geolocation/useGeolocation';
import useGetSavedSearches from '~/hooks/common/services/useGetSavedSearches';
import useGetTrades from '~/hooks/common/services/useGetTrades';
import useSyncGeolocation from '~/hooks/common/sync/useSyncGeolocation';
import useSynchronizeAuth from '~/hooks/common/sync/useSynchronizeAuth';
import useDataDogRUM from '~/hooks/common/telemetry/useDataDogRUM';
import useTrackBrowserCookieIdMismatch from '~/hooks/common/telemetry/useTrackBrowserCookieIdMismatch';
import { useTrackClickEvents } from '~/hooks/common/telemetry/useTrackClickEvents';
import useTrackServerClientMobileMismatch from '~/hooks/common/telemetry/useTrackServerClientMobileMismatch';
import useModalScrollRestoration from '~/hooks/common/ui/useModalScrollRestoration';
import useResizeListener from '~/hooks/common/ui/useResizeListener';
import useConvertFavoriteToSearch from '~/hooks/home/selectors/useConvertFavoriteToSearch';
import useConvertRecentToSearch from '~/hooks/home/selectors/useConvertRecentToSearch';
import useGetBulkAvailability from '~/hooks/home/services/useGetBulkAvailability';
import useGetBulkPricing from '~/hooks/home/services/useGetBulkPricing';
import useGetCreditStatus from '~/hooks/home/services/useGetCreditStatus';
import useGetRecentSearches from '~/hooks/home/services/useGetRecentSearches';
import useGetRecentVehicles from '~/hooks/home/services/useGetRecentVehicles';
import useGetSuggestedForYou from '~/hooks/home/services/useGetSuggestedForYou';
import useGetUserPurchase from '~/hooks/home/services/useGetUserPurchase';
import useSendViewedEvent from '~/hooks/home/telemetry/useSendViewedEvent';
import useSetDataDogContext from '~/hooks/home/telemetry/useSetDataDogContext';
import useTrackHomeAppRouterRendered from '~/hooks/home/telemetry/useTrackHomeAppRouterRendered';
import useTrackHomeLoadTime from '~/hooks/home/telemetry/useTrackHomeLoadTime';
import useTrackMegaVehicle from '~/hooks/home/telemetry/useTrackMegaVehicle';
import {
  useNativeMessageDispatcher,
  useNativeMessageListener
} from '~/native/home';

export default function HomeData() {
  const isAppRouter = useIsAppRouter();
  const isLoggedIn = useIsLoggedIn();
  const nativeDeviceType = useNativeDeviceType();
  const { isAnyModalOpen, isComposerUiModalOpen } = useContext(ModalContext);
  const { preferredAcquisitionNameFromQueryParam } = useContext(TradeContext);
  const { triggerRefreshSrpCard } = useContext(GlobalContext);

  useConvertRecentToSearch();
  useConvertFavoriteToSearch();
  useDataDogRUM();
  useTrackHomeLoadTime();
  useSynchronizeAuth();
  useSendViewedEvent();
  useGetCreditStatus(isLoggedIn);
  useResizeListener(heliosSizes);
  useGetRecentSearches();
  useGetRecentVehicles();
  useGetSuggestedForYou();
  useGetUserPurchase();
  useGetFavorites();
  useSetDataDogContext();
  useTrackHomeAppRouterRendered();
  useGetSavedSearches(triggerRefreshSrpCard);
  useGetTrades(isLoggedIn, preferredAcquisitionNameFromQueryParam);
  useTrackClickEvents();
  useNativeMessageDispatcher();
  useNativeMessageListener();
  useAddNativeClasses(nativeDeviceType.isNative, nativeDeviceType.platform);
  useModalScrollRestoration(isComposerUiModalOpen ? false : isAnyModalOpen);
  useGetBulkAvailability();
  useGetBulkPricing();
  useTrackMegaVehicle();
  useTrackBrowserCookieIdMismatch();
  useTrackServerClientMobileMismatch();
  useGeolocation();
  useSyncGeolocation();

  return isAppRouter ? (
    <AppRouterComposerEvents />
  ) : (
    <PagesRouterComposerEvents />
  );
}
